import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { PublicHeader, Footer } from "../components/PublicChrome";
import { WhatsOn } from "../components/public/WhatsOn";
import { NewsFeed } from "../components/public/NewsFeed";
import { SentimentPanel } from "../components/public/SentimentPanel";
import { Products } from "../components/public/Products";
import { Museum } from "../components/public/Museum";
import { FeedbackDialog } from "../components/public/FeedbackDialog";
import { DgcEmblem } from "../components/Logo";
import { StationStage } from "../components/public/StationStage";
import { Portfolio } from "../components/public/Portfolio";

const HERO = "https://images.unsplash.com/photo-1610889186954-69404e4affee?w=2000&q=80";

const Hero = ({ onFeedback }) => (
  <section id="on-air" className="relative overflow-hidden grain" data-testid="hero-section">
    <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
    <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/30" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-16 grid lg:grid-cols-5 gap-10 items-start">
      <div className="lg:col-span-3 rise min-w-0">
        <div className="flex items-center gap-4 mb-6"><DgcEmblem size={56} /><span className="eyebrow">Despite Media · Live</span></div>
        <StationStage />
        <div className="mt-6 flex flex-wrap gap-3">
          <a href="#news" className="btn-gold" data-testid="hero-news-btn">Read today's stories</a>
          <button onClick={onFeedback} className="btn-ghost" data-testid="hero-feedback-btn"><MessageSquare size={15} /> Send feedback</button>
        </div>
      </div>
      <div className="lg:col-span-2 rise min-w-0" style={{ animationDelay: ".15s" }}><WhatsOn /></div>
    </div>
  </section>
);

export default function PublicHub() {
  const [fb, setFb] = useState(false);
  return (
    <div data-testid="public-hub">
      <PublicHeader onFeedback={() => setFb(true)} />
      <Hero onFeedback={() => setFb(true)} />
      <NewsFeed />
      <SentimentPanel />
      <Products />
      <Museum />
      <Portfolio />
      <section className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="panel p-8 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-6" data-testid="feedback-cta">
          <div>
            <div className="eyebrow mb-2">Your voice reaches the right desk</div>
            <h3 className="font-display text-2xl text-ink">Complaint, praise, news tip or advert enquiry?</h3>
            <p className="text-sm text-slate-400 mt-2">Every message is routed automatically to Programming, Newsroom, Listener Relations, Engineering or Sales.</p>
          </div>
          <button onClick={() => setFb(true)} className="btn-gold shrink-0" data-testid="cta-feedback-btn">Send feedback</button>
        </div>
      </section>
      <Footer />
      <FeedbackDialog open={fb} onOpenChange={setFb} />
    </div>
  );
}
